import { Box, Typography, styled } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundView = () => {
  return (
    <Container>
      <Logo
        src="/static/images/cannatrek.png"
        alt="logo"
      />
      <Title>Cannatrek Consignment Portal</Title>
      <Text>Please select 'home' to access your partner profile</Text>
      <HomeButton to='/'>Home</HomeButton>
    </Container>
  )
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
})

const Logo = styled('img')({
  height: 'auto',
  display: 'block',
  margin: '0 auto',
})

const Title = styled(Typography)({
  fontSize: '40px',
  fontWeight: 'bold',
  marginTop: '32px',
})

const Text = styled(Typography)({
  fontSize: '20px',
  fontWeight: 'normal'
})

const HomeButton = styled(Link)({
  backgroundColor: '#df4c6f',
  fontFamily: 'inherit',
  color: '#fff',
  padding: '10px 44px',
  borderRadius: '4px',
  marginTop: '128px',
})

export default NotFoundView;
